import { Box } from '@dtx-company/shared-components/src/components/atoms/Box/index'
import { CombinedTextProps } from '@dtx-company/shared-components/src/types/atoms'
import { ElementType, FC } from 'react'
import { RichTextField, asHTML } from '@prismicio/client'
import { Text } from '@dtx-company/shared-components/src/components/atoms/Text/index'
import styled from 'styled-components'

type PrismicTextProps = {
  richTextField?: RichTextField
  as?: ElementType
} & CombinedTextProps

const TextWrapper = styled(Box)`
  a {
    color: ${({ color, theme }) => color || theme.colors?.primary?.flowBlue};
    text-decoration: underline;
    font-weight: inherit;
  }
`
const typeToElement = {
  heading1: 'h1',
  heading2: 'h2',
  heading3: 'h3',
  heading4: 'h4',
  heading5: 'h5',
  heading6: 'h6',
  paragraph: 'p',
  preformatted: 'pre',
  strong: 'strong',
  em: 'em',
  'list-item': 'li',
  'o-list-item': 'li',
  'group-list-item': 'ul',
  'group-o-list-item': 'ol',
  list: 'ul',
  oList: 'ol',
  image: 'div',
  embed: 'div',
  hyperlink: 'a',
  label: 'span',
  span: 'span',
  oembed: 'div'
}
/**
 * Wrapper around our Text component to render text coming from Prismic with our
 * default styling and Text component API. It enables certain styling: bold,
 * italics and other nested tags to be respected when specified in Prismic.
 */
const PrismicText: FC<PrismicTextProps> = ({
  richTextField,
  variant,
  fontSize,
  color,
  ...rest
}) => {
  if (!richTextField) return null

  const subText = richTextField?.[0]

  const textInnerHTML =
    asHTML(richTextField, null, (type, _node, _content, children) => {
      // Stop once parent element (a.k.a outermost) is reached to avoid nested h1, p tags, etc.
      // given our Text component already provides the outermost tag
      if (type === richTextField?.[0]?.type) return children
      else return null
    }) || ''

  if (subText && 'text' in subText && !subText?.text) return null
  return (
    <TextWrapper flexDirection="column" color={color}>
      <Text
        variant={variant}
        fontWeight="normal"
        dangerouslySetInnerHTML={{ __html: textInnerHTML }}
        fontSize={fontSize}
        color={color}
        as={richTextField?.[0]?.type ? typeToElement?.[richTextField[0]?.type] : undefined}
        {...rest}
      ></Text>
    </TextWrapper>
  )
}

export default PrismicText
